module.exports = __webpack_public_path__ + "static/media/Rugby Player.17f7f8ad.jpg";